import repositoriesV1 from "../api/v1";
import repositoriesV2 from "../api/v2";

export default defineNuxtPlugin((app) => {
  const config = useRuntimeConfig();

  // Get cookie value at initialization time for SSR compatibility
  const currentCompanyCookie = useCookie("currentCompany");

  // Get request headers for SSR cookie forwarding (must be called at plugin init)
  const requestHeaders = import.meta.server ? useRequestHeaders(['cookie']) : {};

  const client = $fetch.create({
    baseURL: config.public.NUXT_PUBLIC_API_URL + "/api",
    timeout: 180000, // 3 minutes for LinkedIn scraping with many experiences
    retryDelay: 5000,
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
    onRequest({ request, options, error }) {
      if (!options.query) {
        options.query = {};
      }

      if (!options.query.company_id) {
        if (currentCompanyCookie.value) {
          options.query.company_id = currentCompanyCookie.value;
        }
      }

      if (import.meta.server && requestHeaders.cookie) {
        options.headers = {
          ...options.headers,
          cookie: requestHeaders.cookie,
        };
      }
    },
    async onResponseError(error) {
      const { response, options } = error;

      // Only handle UI redirects and alerts on client-side
      if (import.meta.client) {
        const alerts = useAlerts();
        const router = useRouter();

        if (response.status === 401) {
          const route = useRoute();
          if (route.path !== '/login') {
            router.push("/login");
          }
        }

        // Callers can opt out of the generic alert when they surface their own,
        // user-friendly message for an expected error (avoids a duplicate alert
        // showing the raw, untranslated backend error key).
        if ((options as any)?.skipGlobalErrorAlert) {
          return error;
        }

        let errorData = response._data?.data;

        // Handle blob responses (e.g., file preview that returns an error)
        if (!errorData && response._data instanceof Blob) {
          try {
            const text = await response._data.text();
            const parsed = JSON.parse(text);
            errorData = parsed.data;
          } catch {
            // Blob is not JSON, ignore
          }
        }

        if (errorData && (response.status >= 400 && response.status < 500)) {
          alerts.add({
            title: errorData.title,
            description: errorData.detail,
          });
        } else {
          alerts.add({
            title: 'Une erreur est survenue',
            description: 'Nos équipes sont en train de l\'étudier.',
          });
        }
      }

      return error;
    },
  });

  return {
    provide: {
      api: () => {
        return {
          client,
          v1: repositoriesV1(client),
          v2: repositoriesV2(client),
        };
      },
    },
  };
});
